export default {
  getChecklist: (state) => state.checklist,
};
